import metadata from 'libphonenumber-js/min/metadata'

import { createPhoneInput } from '../modules/react-hook-form/PhoneInputWithCountry.js'

export default createPhoneInput(metadata)